import React from "react";

import { Box, Typography } from "@mui/material";

import { ErrorRounded } from "@mui/icons-material";

import { StyledButton } from "../../Button/StyledButton";

interface NotFoundProps {
  goBack?: () => void;
  /** Defaults to English: the dashboard renders this too and is English-only, so
   * translation is a call-site decision. */
  title?: string;
  body?: string;
  goBackLabel?: string;
  goHomeLabel?: string;
}

// This is react based, and only shows up when
// the react router can't find a page.
// The 404 page for the complete app is hosted in Framer.
export const NotFound = ({
  goBack,
  title = "Ingredi - don't - find",
  body = "We couldn't find the page you were looking for. Let's go back and to find what your looking for?",
  goBackLabel = "Go back",
  goHomeLabel = "Go home",
}: NotFoundProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 3,
        maxWidth: 600,
        margin: "5% auto",
        textAlign: "center",
      }}
    >
      <ErrorRounded
        sx={({ palette }) => ({ color: palette.info.light })}
        fontSize={"large"}
      />
      <Typography variant={"h1"}>{title}</Typography>
      <Typography variant={"body1"}>{body}</Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
        }}
      >
        <StyledButton
          label={goBackLabel}
          isOscarDesign
          variant={"text"}
          onClick={goBack}
        />
        <StyledButton
          label={goHomeLabel}
          variant={"contained"}
          isOscarDesign
          onClick={() => open("https://ingredifind.com", "_self")}
        />
      </Box>
    </Box>
  );
};
